module.exports = __webpack_public_path__ + "h5/img/site_logo.b1a01fcc.png";